import gql from 'graphql-tag';

export const changeExperimentPlatformMigration = gql`
  mutation changeExperimentPlatformMigration {
    chimera {
      upsertUserExperimentsPlatformMigration(isEnabled: true)
    }
  }
`;
